import UserComments from "./UserComments";


const Discussion = () => {

  return (
    <div className="formbg mb-3">
      <button
        className="discussionTabs"
        style={{
          backgroundColor: "var(--background-primary)",
          cursor: "default",
        }}
        value=""
      >
        Discussion
      </button>
      <div className="comments_safari bg-white">
        <UserComments />
      </div>
    </div>
  )
}

export default Discussion;